
<template>
  <!--添加人员-->
  <div class="advanced-form">
    <a-form :form="form">
      <div class="card">
        <div v-if="!isEdit" class="card-body">
          <a-steps class="blacklist-steps" :current="currentStep" :status="stepStatus">
            <a-step v-for="item in steps" :key="item.title" :title="item.title" />
          </a-steps>
        </div>

        <div v-if="currentStep===0 && isEdit===false" class="card-body">
          <a-form-item v-bind="{ labelCol: {span: 7}, wrapperCol: {span: 10} }" label="账号" has-feedback>
            <a-input v-decorator="['mobile_phone', decoratorOptions.mobile_phone]" placeholder="请输入手机"/>
          </a-form-item>
        </div>
      </div>

      <template v-if="currentStep===1 || isEdit===true">
        <div class="card">
          <div class="card-head">
            <h3>基本信息</h3>
          </div>
          <div class="card-body">
            <a-row type="flex" justify="space-between">
              <a-col v-for="(item, index) of baseInfoList" :key="index" v-bind="$store.state.advanced_colWidth">
                <a-form-item :label="item.label">
                  <div v-if="item.key==='avatar_url'" class="pic-box">
                    <img :src="item.value" alt="">
                  </div>
                  <span v-else class="ant-form-text">{{item.value}}</span>
                </a-form-item>
              </a-col>
            </a-row>
          </div>
        </div>

        <div class="card">
          <div class="card-head">
            <h3>预警标签<span>（多选）</span></h3>
          </div>
          <div class="card-body">
            <a-form-item v-bind="{ labelCol: {span: 0}, wrapperCol: {span: 24} }" label="">
              <a-checkbox-group @change="tagChange" v-decorator="['sys_label', decoratorOptions.sys_label]"
                                :style="{width: '100%'}">
                <a-row>
                  <a-col v-for="(item, order) of blackListLabel" :key="order" :span="6">
                    <a-checkbox v-if="item.label!=='其他'" :value="item.value">{{item.label}}</a-checkbox>
                    <template v-else>
                      <a-checkbox :value="item.value">{{item.label}}
                        <a-input class="input-tag" v-decorator="['own_label', decoratorOptions.own_label]"
                                 :disabled="otherAble" placeholder="请输入标签"/>
                      </a-checkbox>
                    </template>
                  </a-col>
                </a-row>
              </a-checkbox-group>
            </a-form-item>
          </div>
        </div>
      </template>
    </a-form>

    <div class="toolbar">
      <div class="btn-group">
        <template v-if="!isEdit">
          <a-button v-if="currentStep < steps.length - 2" type="primary" @click="next" size="large">下一步</a-button>
          <a-button v-if="currentStep === steps.length - 2" type="primary" @click="handleSubmit" size="large">立即添加</a-button>
          <a-button v-if="currentStep>0" @click="currentStep--" size="large">上一步</a-button>
        </template>
        <a-button v-else type="primary" @click="editSubmit" size="large">确定</a-button>
      </div>
    </div>
  </div>
</template>

<script>
import { fetchSelect } from '../../../utils/mixins';
import { inputSearch } from 'ant-design-vue-admin-x';
export default {
  mixins: [inputSearch, fetchSelect],
  name: 'addBlackList',
  data () {
    return {
      btnLoading: { loading: false },
      isEdit: false,
      otherAble: true,
      formValues: {},
      currentStep: 0,
      stepStatus: 'process',
      steps: [{ title: '填写账号信息' }, { title: '确认信息' }, { title: '完成' }],
      communityList: [],
      blackListLabel: [],
      baseInfoList: [
        {key: 'true_name', label: '真实姓名/昵称', value: ''},
        {key: 'mobile', label: '手机号', value: ''},
        {key: 'avatar_url', label: '头像', value: ''},
        {key: 'sex', label: '性别', value: ''},
        {key: 'birthday', label: '出生年月', value: ''},
        {key: '', label: '', value: ''}
      ],
      decoratorOptions: {
        mobile_phone: {
          rules: [
            { required: true, message: '请输入手机号' },
            { pattern: this.REG.mobile, message: this.MESSAGE.mobile }
          ]
        },
        sys_label: {
          rules: [{ required: true, message: '请选择预警标签' }]
        },
        own_label: {
          rules: [{ required: false, message: '请输入自定义标签' }]
        }
      }
    };
  },
  beforeCreate () {
    this.form = this.$form.createForm(this);
  },
  created () {
    if (this.$route.query.id) {
      this.isEdit = true;
      this.getDetail();
    }
    this.getSelect();
  },
  methods: {
    /* 获取下拉 */
    getSelect () {
      this.typeSelect({
        query: 'sys_label',
        handle: (data) => {
          this.blackListLabel = data;
        }
      });
    },
    /* 获取详情 */
    getDetail () {
      this.$get({
        url: `/blacklist/${this.$route.query.id}`,
        params: {}
      }).then(({data}) => {
        this.setFormData(data);
        this.$nextTick(() => {
          let arr = data.sys_label.split(',');
          let labelArr = [];
          arr && arr.forEach(el => labelArr.push(parseInt(el)));
          this.blackListLabel.forEach((el) => {
            if (el.label === '其他' && labelArr.includes(el.value)) {
              this.otherAble = false;
            }
          });
          this.form.setFieldsValue({ sys_label: labelArr, own_label: data.own_label });
        });
      });
    },
    /* 标签修改事件 */
    tagChange (e) {
      let otherVal;
      this.blackListLabel.forEach((el) => {
        if (el.label === '其他') {
          otherVal = el.value;
        }
      });
      if (e.includes(otherVal)) {
        this.otherAble = false;
      } else {
        this.otherAble = true;
        this.form.setFieldsValue({ own_label: undefined });
      }
    },
    /* 下一步 */
    next () {
      this.form.validateFields(['mobile_phone'], (err, values) => {
        if (err) {
          this.stepStatus = 'error';
          return false;
        } else {
          this.$post({
            url: '/blacklist/check',
            params: values
          }).then(({data}) => {
            this.stepStatus = 'process';
            this.formValues = {...this.formValues, ...values};
            this.currentStep++;
            this.setFormData(data);
          });
        }
      });
    },
    setFormData (data) {
      this.baseInfoList.forEach((el) => {
        for (let item in data) {
          if (el.key === item) {
            el.value = data[item];
          }
        }
      });
    },
    /* 编辑标签 */
    editSubmit () {
      this.form.validateFields((err, values) => {
        if (err) { return false; }
        if (!values.sys_label.includes(10) || !values.own_label) {
          values.own_label = '';
        }
        values.sys_label && (values.sys_label = values.sys_label.join(','));
        this.$put({
          url: `/blacklist/${this.$route.query.id}`,
          params: values
        }).then(({data}) => {
          this.$message.success('编辑成功！');
          this.$router.go(-1);
        });
      });
    },
    /* 表单提交 */
    handleSubmit  () {
      this.form.validateFields(['sys_label', 'own_label'], (err, values) => {
        if (err) {
          this.stepStatus = 'error';
          return false;
        } else {
          values.sys_label && (values.sys_label = values.sys_label.join(','));
          values = {...values, ...this.formValues};

          this.$post({
            url: '/blacklist/add_blacklist',
            params: values
          }).then((res) => {
            this.stepStatus = 'finish';
            this.$message.success('添加成功！');
            this.$router.go(-1);
          });
        }
      });
    }
  }
};
</script>
